import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { logException } from './Sentry';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query): void => {
      if (query.meta?.errorMessage) {
        toast.error(`${query.meta.errorMessage}`);
      }
      logException({
        error,
        message: 'Query error',
        errorData: query.queryHash,
      });
    },
  }),
  mutationCache: new MutationCache({
    onSuccess(_data, _variables, _context, mutation): void {
      if (mutation.options.meta?.successMessage) {
        const { successMessage } = mutation.options.meta;
        toast.success(`${successMessage}`);
      }
    },
    onError(error, _variables, _context, mutation): void {
      if (mutation.options.meta?.errorMessage) {
        const { errorMessage } = mutation.options.meta;
        toast.error(`${errorMessage}`);
      }
      // todo edit this once mutations are implemented
      logException({
        error,
        message: 'Mutation error',
      });
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 10,
      // onError: (): void => {
      //   toast.error('Eitthvað fór úrskeiðis. Reyndu aftur síðar');
      // },
    },
    mutations: {
      // onError: (): void => {
      //   toast.error('Eitthvað fór úrskeiðis. Reyndu aftur síðar');
      // },
    },
  },
});
